module.exports = __webpack_public_path__ + "files/faa70eeb643fdd8f72f1f8f53588c7f2.png";